const dutyHandover = r => require.ensure([], () => r(require('@/views/leaderDuty/dutyHandover.vue'), 'dutyHandover'))
const handoverSubmit = r =>
  require.ensure([], () => r(require('@/views/leaderDuty/handoverSubmit.vue'), 'handoverSubmit'))
const historyDutyRecord = r =>
  require.ensure([], () => r(require('@/views/leaderDuty/historyDutyRecord.vue'), 'historyDutyRecord'))
const dutyPersonal = r => require.ensure([], () => r(require('@/views/leaderDuty/dutyPersonal.vue'), 'dutyPersonal'))
const AocDuty = r => require.ensure([], () => r(require('@/views/leaderDuty/AocDuty.vue'), 'AocDuty'))
const AocDutyDetail = r => require.ensure([], () => r(require('@/views/leaderDuty/AocDutyDetail.vue'), 'AocDutyDetail'))
const emergencyList = r =>
  require.ensure([], () => r(require('@/views/emergencyLog/emergencyList.vue'), 'emergencyList'))
const emergencyBoard = r =>
  require.ensure([], () => r(require('@/views/emergencyLog/emergencyBoard.vue'), 'emergencyBoard'))
const injuriesDetail = r =>
  require.ensure([], () => r(require('@/views/emergencyLog/injuriesDetail.vue'), 'injuriesDetail'))
const eventLog = r => require.ensure([], () => r(require('@/views/emergencyLog/eventLog.vue'), 'eventLog'))
const downloadApp = r => require.ensure([], () => r(require('@/views/download/downloadApp.vue'), 'downloadApp'))
const downloadFlyApp = r => require.ensure([], () => r(require('@/views/download/downloadFlyApp.vue'), 'downloadFlyApp'))
const router = [
  {
    path: '/dutyHandover',
    name: 'dutyHandover',
    meta: {
      title: '值班交接'
    },
    component: dutyHandover
  },
  {
    path: '/handoverSubmit',
    name: 'handoverSubmit',
    meta: {
      title: '值班交接'
    },
    component: handoverSubmit
  },
  {
    path: '/historyDutyRecord',
    name: 'historyDutyRecord',
    meta: {
      title: '历史值班记录'
    },
    component: historyDutyRecord
  },
  {
    path: '/dutyPersonal',
    name: 'dutyPersonal',
    meta: {
      title: '当日值班人员信息'
    },
    component: dutyPersonal
  },
  {
    path: '/AocDuty',
    name: 'AocDuty',
    meta: {
      title: 'AOC值班'
    },
    component: AocDuty
  },
  {
    path: '/AocDutyDetail',
    name: 'AocDutyDetail',
    meta: {
      title: '当前值班席位'
    },
    component: AocDutyDetail
  },
  {
    path: '/emergencyList',
    name: 'emergencyList',
    meta: {
      title: '应急日志'
    },
    component: emergencyList
  },
  {
    path: '/downloadApp',
    name: 'downloadApp',
    meta: {
      title: '下载app'
    },
    component: downloadApp
  },
  {
    path: '/downloadFlyApp',
    name: 'downloadFlyApp',
    meta: {
      title: '下载飞行app'
    },
    component: downloadFlyApp
  },
  {
    path: '/emergencyBoard',
    name: 'emergencyBoard',
    meta: {
      title: '信息看板'
    },
    component: emergencyBoard
  },
  {
    path: '/eventLog',
    name: 'eventLog',
    meta: {
      title: '事件日志'
    },
    component: eventLog
  },
  {
    path: '/injuriesDetail',
    name: 'injuriesDetail',
    meta: {
      title: '伤亡信息'
    },
    component: injuriesDetail
  }
]

export default router
